import React from "react";
import SingleProgress from "../../container/cards/SingleProgress";
import Vessel from "../../container/vessel/Vessel";
import VesselOverview from "../../container/vessel-overview/VesselOverview";
import { ConfigProvider } from "antd";
import { useSelector } from "react-redux";
import FeumOverview from "../../container/feumoverview/FeumOverview";

const Vessels = () => {

  const selectedVessel = useSelector((state) => state.vessel.selectedVessel)
  const penalty_current_percent = ((selectedVessel?.penalty_current) / (selectedVessel?.penalty_ytd + selectedVessel?.penalty_current)) * 100
  const penalty_tyd_percent = ((selectedVessel?.penalty_ytd) / (selectedVessel?.penalty_ytd + selectedVessel?.penalty_current)) * 100
  return (
    <ConfigProvider
      theme={{
        components: {
          Progress: {
            lineBorderRadius: 8,
          },
          Descriptions: {
            itemPaddingBottom: "10px"
          }
        },
      }}
    >
      <main className="main-board">
        <div className="vessal-dashboard">
          {/* <SingleProgress
            title={"Penalty Current"}
            description={selectedVessel?.penalty_current !== null ? selectedVessel?.penalty_current?.toFixed(3) : "0.0"}
            percent={penalty_current_percent}
            color={"#55D99F"}
            textColor={"#377E36"}
            tagColor={"#E0F0E4"}
          />
          <SingleProgress
            title={"Penalty (YTD)"}
            description={selectedVessel?.penalty_ytd?.toFixed(3)}
            percent={penalty_tyd_percent}
            color={"#FFAAAA"}
            textColor={"#FF8585"}
            tagColor={"rgba(255, 133, 133, 0.20)"}
          /> */}

          <div className="voyage-item vessel-item">
            <FeumOverview />
          </div>
          <div className="vessel-item1">
            <Vessel />
          </div>
          <div className="vessel-item2">
            <VesselOverview />
          </div>
        </div>
      </main>
    </ConfigProvider>
  );
};

export default Vessels;
